module.exports = __webpack_public_path__ + "static/media/ic_hs_b3_myway.2bdddf96.svg";